import { Pages, routeBuilders, routeUpdaters } from "../routes/routes.state";
import { CurrentPage } from "../../../Shared/Frontend/utils/routes.shared";
import { application, ApplicationState } from "../allIncludedModules";

export type ProductId = number

export type State = {
  page: CurrentPage<Pages>,
  lastUpdate?: "shopping cart" | "products"
} & ApplicationState

export const initialState: State = ({
  ...application.initialState(),
  page: routeBuilders.home.make({})  
})

export const stateUpdaters = {
  routes: routeUpdaters
}
